import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid } from "@material-ui/core";
import { STEPPER_MEDICACION } from "../../../utils/constants";
import {
  setActiveStep,
  cleanAfiliadoSeleccionado,
  clearReducer,
} from "../../../actions/empadronamiento/Empadronamiento";
import { MedicacionAccordionHistorial } from "./Accordions/MedicacionAccordionHistorial";
import { MedicacionStepper } from "../UI/MedicacionStepper";
import { MedicacionAfiliadoBuscador } from "./MedicacionAfiliadoBuscador";
import { MedicacionDatosTitular } from "./MedicacionDatosTitular";
import { MedicacionDetalleSolicitud } from "./MedicacionDetalleSolicitud";
import { MedicacionMedicamentos } from "./MedicacionMedicamentos";
import { MedicacionConfirmacion } from "./MedicacionConfirmacion";
import { MedicacionEmpadronamientosActivosAccordionHistorial } from "./Accordions/MedicacionEmpadronamientosActivosAccordionHistorial";
import { MedicacionDocumentacionDetalle } from "./MedicacionDocumentacionDetalle";

export const MedicacionIngresoHome = (props) => {
  const dispatch = useDispatch();
  const { activeStep = 0 } = useSelector((state) => state.empadronamiento);

  const cleanState = () => {
    dispatch(setActiveStep(STEPPER_MEDICACION.BUSCADOR));
    dispatch(cleanAfiliadoSeleccionado());
    dispatch(clearReducer());
  };

  useEffect(() => {
    if (!props.fromBandeja) cleanState();
  }, []);

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <MedicacionStepper activeStep={activeStep} />
      </Grid>
      {activeStep === STEPPER_MEDICACION.DATOS_TITULAR && (
        <Grid item xs={12}>
          <MedicacionEmpadronamientosActivosAccordionHistorial />
        </Grid>
      )}
      {activeStep === STEPPER_MEDICACION.DATOS_TITULAR && (
        <Grid item xs={12}>
          <MedicacionAccordionHistorial />
        </Grid>
      )}
      <Grid item xs={11}>
        {activeStep === STEPPER_MEDICACION.BUSCAR_TITULAR && (
          <MedicacionAfiliadoBuscador />
        )}
        {activeStep === STEPPER_MEDICACION.DATOS_TITULAR && (
          <MedicacionDatosTitular />
        )}
        {activeStep === STEPPER_MEDICACION.DETALLE && (
          <MedicacionDetalleSolicitud
            fromBandeja={props.fromBandeja} />
        )}
        {
          activeStep === STEPPER_MEDICACION.DOCUMENTACION && (
            <MedicacionDocumentacionDetalle />
          )
        }
        {activeStep === STEPPER_MEDICACION.MEDICAMENTOS && (
          <MedicacionMedicamentos />
        )
        }
        {activeStep === STEPPER_MEDICACION.CONFIRMACION && (
          <MedicacionConfirmacion />
        )}
      </Grid>

    </React.Fragment>
  );
};
